import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Spinner } from "@/components/ui/spinner";
import { Textarea } from "@/components/ui/textarea";

/**
 * Declining is a message, not a click: the applicant or steward is told, in
 * the admin's words, why. So the button asks for the note before it does
 * anything — a decline sent with no explanation is what makes people write
 * to ask, and the note is the email's whole body.
 */
export function DeclineDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel = "Decline",
  busy = false,
  onConfirm,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  confirmLabel?: string;
  busy?: boolean;
  onConfirm: (note: string) => void;
}) {
  const [note, setNote] = useState("");
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) setNote("");
        onOpenChange(next);
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Label htmlFor="decline-note">Note to send</Label>
          <Textarea
            id="decline-note"
            rows={4}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="What they should know, in your words."
          />
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)} disabled={busy}>
            Cancel
          </Button>
          <Button variant="outline" disabled={busy || !note.trim()} onClick={() => onConfirm(note.trim())}>
            {busy && <Spinner data-slot="icon" />}
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
